import * as Constants from '../constants/organization';

const initialState = {
  organizations: [],
  activeOrganization: null,
  activeOrganizationSubmission: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.payload,
      };
    case Constants.GET_ORGANIZATION_SUCCESS:
    case Constants.UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        activeOrganization: action.payload,
      };
    case Constants.GET_ORGANIZATION_SUBMISSION_SUCCESS:
    case Constants.UPDATE_ORGANIZATION_SUBMISSION_SUCCESS:
      return {
        ...state,
        activeOrganizationSubmission: action.payload,
      };
    case Constants.CLEAR_ORGANIZATION_SUBMISSION:
      return {
        ...state,
        activeOrganizationSubmission: null,
      };
    case Constants.CLEAR_ORGANIZATION:
      return {
        ...state,
        activeOrganization: null,
      };
    case Constants.GET_ORGANIZATION_STATISTICS_SUCCESS:
      return {
        ...state,
        activeOrganization: {
          ...state.activeOrganization,
          statistics: action.payload,
        },
      };
    default:
      return state;
  }
};
